import './index.scss';

import React from 'react';
import { connect } from 'react-redux';
import DatePicker from '@/components/common/DatePicker2/DatePicker';
import Account from '@/components/common/Timelog/Fields/Account/Account';
import Workstreams from '@/components/common/Timelog//Fields/Workstreams/Workstreams';
import Tasks from '@/components/common/Timelog//Fields/Tasks/Tasks';
import Description from '@/components/common/Timelog//Fields/Description/Description';
import Time from '@/components/common/Timelog//Fields/Time/Time';
import moment from 'moment';
import Axios from '@/axiosPool';
import { showToast } from '@/globalFunction';
import Tooltip from '@/components/common/Elements/Tooltip/Tooltip';
import DiscardChanges from '@/components/common/DiscardChanges/DiscardChanges';
import NavigationBLocker from '@/components/common/NavigationBlocker/NavigationBlocker';
import { addTimes } from '@/globalFunction';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Toast from '@/components/common/Toast/Toast';
import _ from 'lodash';
import { transformTaskList } from '@/reducers/project/processes/tasks/service';

const INITIAL_STATE = {
  from: moment().format('HH:mm'),
  to: moment().add(1, 'hours').format('HH:mm'),
  oldFrom: moment().format('HH:mm'),
  oldTo: moment().add(1, 'hours').format('HH:mm'),
  selectedDate: moment(),
  description: '',
  timelog: {
    selected: {
      account: null,
      workstream: null,
      task: null,
    },
    values: {
      account: null,
      workstream: null,
      task: null,
    },
  },
};

@connect((store) => {
  return {
    workstreams: store.workstreams,
    settings: store.settings,
    loggedUser: store.loggedUser,
    timelog: store.timelog,
    globalConfig: store.globalConfig,
    task: store.task,
  };
})
class LogActivity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      from: moment().format('HH:mm'),
      to: moment().add(1, 'hours').format('HH:mm'),
      oldFrom: moment().format('HH:mm'),
      oldTo: moment().add(1, 'hours').format('HH:mm'),
      selectedDate: moment(),
      description: '',
      show_timelog_modal: false,
      isModalReady: false,
      openToast: false,
      selected: {
        account: null,
        workstream: null,
        task: null,
      },
      timelog: {
        selected: {
          account: null,
          workstream: null,
          task: null,
        },
        values: {
          account: null,
          workstream: null,
          task: null,
        },
      },
    };
    _.map(
      [
        'handleChange',
        'handleSave',
        'handleOnBlurTime',
        'handleClose',
        'onDiscardChanges',
        'handleDiscard',
        'hasChanges',
      ],
      (fn) => {
        this[fn] = this[fn].bind(this);
      }
    );
  }
  componentDidMount() {
    $('#logActivityTimeModal').on('show.bs.modal', () => {
      $('.generalAddTimelog').addClass('active');
      $('#addTaskTimelog').addClass('active');
      const { timelog } = this.props;
      //update date/time if modal is show
      setTimeout(() => {
        this.setState({
          isModalReady: true,
          ...(!timelog.timelog.id
            ? {
                from: moment().format('HH:mm'),
                to: moment().add(1, 'hours').format('HH:mm'),
                oldFrom: moment().format('HH:mm'),
                oldTo: moment().add(1, 'hours').format('HH:mm'),
                selectedDate: moment(),
              }
            : {}),
        });
      }, 100);
    });
    $('#logActivityTimeModal').on('hidden.bs.modal', () => {
      $('.generalAddTimelog').removeClass('active');
      $('#addTaskTimelog').removeClass('active');
      this.setState({ isModalReady: false });
    });
  }
  componentDidUpdate(prev) {
    const { task, timelog } = this.props;

    if (!_.isEqual(prev.task.Selected, task.Selected)) {
      if (task.Selected.id) {
        const selected = this.props.task.Selected;
        this.setState({
          timelog: {
            ...this.state.timelog,
            values: {
              account: selected.task_project.project,
              workstream: selected.workstream.workstream,
              task: selected.task,
            },
            selected: {
              account: selected.task_project.id,
              workstream: selected.workstream.id,
              task: selected.id,
            },
          },
        });
      } else {
        this.setState({
          ...INITIAL_STATE,
        });
      }
    }

    if (
      !_.isEqual(prev.timelog.timelog, timelog.timelog) &&
      timelog.timelog.id &&
      task.Selected.id
    ) {
      const selected = this.props.task.Selected;
      const selectedLog = timelog.timelog;
      this.setState({
        timelog: {
          ...this.state.timelog,
          values: {
            account: selected.task_project.project,
            workstream: selected.workstream.workstream,
            task: selected.task,
          },
          selected: {
            account: selected.task_project.id,
            workstream: selected.workstream.id,
            task: selected.id,
          },
        },
        from: moment(selectedLog.from, 'hh:mm A').format('HH:mm'),
        to: moment(selectedLog.to, 'hh:mm A').format('HH:mm'),
        oldFrom: moment(selectedLog.from, 'hh:mm A').format('HH:mm'),
        oldTo: moment(selectedLog.to, 'hh:mm A').format('HH:mm'),
        selectedDate: moment(selectedLog.datelog),
        description: selectedLog.description,
      });
    }
  }
  handleChange(e) {
    let selected = this.state.timelog.selected;
    if (e.name === 'account') {
      selected = {
        account: null,
        workstream: null,
        task: null,
      };
    }
    if (e.name === 'workstream') {
      selected = {
        account: selected.account,
        workstream: null,
        task: null,
      };
    }
    if (e.name === 'task') {
      if (e.data) {
        const workstream = e.data.workstream;
        this.setState({
          selected: {
            ...this.state.selected,
            workstream: {
              value: workstream.id,
              label: workstream.workstream,
              color: workstream.color,
            },
          },
        });
        selected = {
          account: selected.account,
          workstream: workstream.id,
          task: null,
        };
      }
    }
    selected[e.name] = e.value;
    this.setState({ timelog: { ...this.state.timelog, selected } });
    //dispatch({type:"SET_SELECTED_ACTION", selected})
  }

  handleClose() {
    const { dispatch, task } = this.props;
    this.setState({
      ...INITIAL_STATE,
      ...(task.Selected.id
        ? {
            timelog: {
              ...this.state.timelog,
              selected: {
                account: task.Selected.task_project.id,
                workstream: task.Selected.workstream.id,
                task: task.Selected.id,
              },
              value: {
                account: task.Selected.task_project.project,
                workstream: task.Selected.workstream.workstream,
                task: task.Selected.task,
              },
            },
          }
        : {}),
    });
    dispatch({ type: 'SET_SELECTED_TIMELOG', timelog: {} });
    $(`#logActivityTimeModal`).modal('hide');
  }

  handleSave() {
    const { timelog: timelogStore, dispatch, task } = this.props;
    const { from, to, selectedDate, description, timelog } = this.state;
    const { selected } = timelog;
    let url = 'api/timeLog';
    let promise = null;
    let params = {
      projectId: selected.account ? selected.account : null,
      workstreamId: selected.workstream ? selected.workstream : null,
      taskId: selected.task ? selected.task : null,
      datelog: moment(selectedDate).format('YYYY-MM-DD'),
      from: moment(from, 'HH:mm').format('HH:mm:ss'),
      to: moment(to, 'HH:mm').format('HH:mm:ss'),
      description,
    };
    if (timelogStore.timelog.id) {
      params = {
        datelog: moment(this.state.selectedDate).format('YYYY-MM-DD'),
        from: moment(this.state.from, 'HH:mm').format('HH:mm:ss'),
        to: moment(this.state.to, 'HH:mm').format('HH:mm:ss'),
        description: this.state.description,
      };
      url += `/${timelogStore.timelog.id}`;
      promise = Axios.put(url, params);
    } else {
      promise = Axios.post(url, params);
    }

    promise.then((res) => {
      if (res) {
        this.setState(
          {
            ...INITIAL_STATE,
            openToast: true,
            ...(task.Selected.id
              ? {
                  timelog: {
                    ...this.state.timelog,
                    selected: {
                      account: task.Selected.task_project.id,
                      workstream: task.Selected.workstream.id,
                      task: task.Selected.id,
                    },
                    value: {
                      account: task.Selected.task_project.project,
                      workstream: task.Selected.workstream.workstream,
                      task: task.Selected.task,
                    },
                  },
                }
              : {}),
          },
          () => {
            // Continue to dispatch to catch case of adding quick link in actual time keep page
            // TODO: Check if current page is timekeep only and do this conditionally?
            if (timelogStore.timelog.id) {
              dispatch({ type: 'SET_SELECTED_TIMELOG', timelog: {} });
            } else {
              dispatch({
                type: 'SET_TIMELOG_LIST',
                list: [...[res.data.result], ...timelogStore.list],
              });
            }

            if (task.Selected.id) {
              const params = {
                taskId: task.Selected.id,
                page: 1,
              };
              const activity = {
                taskId: task.Selected.id,
                page: 1,
              };
              Axios.get(`api/activityLog`, activity).then((c) => {
                if (c.status === 200) {
                  const { data } = c;
                  dispatch({
                    type: 'SET_ACTIVITYLOG_LIST',
                    list: data.result,
                    count: data.count,
                  });
                }
              });
              Axios.get(`/api/timeLog/tasklog`, params).then((c) => {
                if (c) {
                  const timelogTotal = addTimes(
                    task.Selected.timelogTotal,
                    res.data.result.duration
                  );
                  dispatch({
                    type: 'SET_TASK_SELECTED',
                    Selected: { ...task.Selected, timelogTotal },
                  });
                  dispatch({
                    type: 'SET_TASKTIMELOG_LIST',
                    list: c.data.result,
                    count: c.data.count,
                  });
                  dispatch({
                    type: 'SET_TOTAL_HOURS',
                    total: c.data.total_hours,
                  });

                  const updatedSelectedTask = {
                    ...task.Selected,
                    timelog: timelogTotal,
                  };
                  const list = transformTaskList([updatedSelectedTask]);

                  dispatch({ type: 'UPDATE_TASKS_LIST', list: list });
                }
              });
            }
          }
        );

        // showToast( "success", "Time log saved!" );
        this.handleClose();
      }
    });
  }

  handleOnBlurTime(e) {
    const { oldFrom, oldTo, to, from } = this.state;
    const { timelog } = this.props;
    const timelogId = timelog.timelog.id;
    if (e.value) {
      if (
        e.name === 'from' &&
        moment(e.value, 'HH:mm').isAfter(moment(this.state.to, 'HH:mm'))
      ) {
        if (!timelogId) {
          let resetValue = moment(e.value, 'HH:mm')
            .add(1, 'hours')
            .format('HH:mm');
          if (moment(e.value, 'HH:mm').isAfter(moment('22:59', 'HH:mm'))) {
            resetValue = '23:59';
          }
          this.setState({
            to: resetValue,
            oldFrom: e.value,
            oldTo: resetValue,
          });
        } else {
          this.setState({
            from: moment(to, 'HH:mm').subtract(1, 'hours').format('HH:mm'),
          });
          showToast('error', 'Start time is greater than End time');
        }
      } else if (
        e.name === 'to' &&
        moment(e.value, 'HH:mm').isBefore(moment(this.state.from, 'HH:mm'))
      ) {
        if (!timelogId) {
          let resetValue = moment(from, 'HH:mm')
            .add(1, 'hours')
            .format('HH:mm');
          if (moment(from, 'HH:mm').isAfter(moment('22:59', 'HH:mm'))) {
            resetValue = '23:59';
          }
          this.setState({ to: resetValue, oldTo: resetValue });
        } else {
          this.setState({
            to: moment(from, 'HH:mm').add(1, 'hours').format('HH:mm'),
          });
          showToast('error', 'End time is less than Start time');
        }
      } else {
        if (e.name === 'from') {
          this.setState({ oldFrom: e.value });
        } else if (e.name === 'to') {
          this.setState({ oldTo: e.value });
        }

        this.handleChange(e);
      }
    } else {
      if (e.name === 'from') {
        this.setState({ from: oldFrom });
      } else if (e.name === 'to') {
        this.setState({ to: oldTo });
      }
      showToast('error', 'Time is required!');
    }
  }

  onDiscardChanges() {
    const { task } = this.props;
    $(`#timelogDiscardChanges`).modal('hide');

    this.handleClose();
  }
  hasChanges() {
    const { timelog, task } = this.props;
    const stateLog = this.state;
    const storeLog = timelog.timelog;
    let hasChanges = false;
    //handle on edit
    if (timelog.timelog.id) {
      hasChanges =
        stateLog.dateLog !== storeLog.dateLog ||
        stateLog.from !== moment(storeLog.from, 'hh:mm a').format('HH:mm') ||
        stateLog.to !== moment(storeLog.to, 'hh:mm a').format('HH:mm') ||
        stateLog.description !== storeLog.description ||
        !stateLog.selectedDate
          .startOf('d')
          .isSame(moment(storeLog.datelog, 'DD-MMM YYYY').startOf('d'));
    } else {
      //add on task
      if (task.Selected.id) {
        hasChanges =
          stateLog.from !== stateLog.oldFrom ||
          stateLog.to !== stateLog.oldTo ||
          !stateLog.selectedDate.startOf('d').isSame(moment().startOf('d')) ||
          stateLog.description !== '';
      } else {
        //add on quick
        const selected = stateLog.timelog.selected;
        hasChanges =
          stateLog.from !== stateLog.oldFrom ||
          stateLog.to !== stateLog.oldTo ||
          !stateLog.selectedDate.startOf('d').isSame(moment().startOf('d')) ||
          stateLog.description !== '' ||
          selected.account !== null ||
          selected.workstream !== null ||
          selected.task !== null;
      }
    }
    return hasChanges;
  }

  handleDiscard() {
    const hasChanges = this.hasChanges();
    console.log('handleDiscard');
    if (hasChanges) {
      $(`#timelogDiscardChanges`).modal('show');
    } else {
      this.handleClose();
    }
  }

  render() {
    const { loggedUser, timelog: timelogStore, task } = this.props;
    const {
      from,
      to,
      selectedDate,
      description,
      timelog,
      selected,
      show_timelog_modal,
    } = this.state;
    const { values } = timelog;
    const start = from;
    const end = to;
    const global = this.props.globalConfig.Config;

    const config = global.timelog ? global.timelog[0] : null;

    const days = config ? parseInt(config.value) : 0;
    const masterAdmin = loggedUser.data.userRole < 2;

    const handleChangeDate = (date) => {
      if (date.isValid()) {
        if (masterAdmin) {
          this.setState({ selectedDate: date });
        } else {
          const disabledDate = moment().subtract('day', days);
          if (date.startOf('d').isBefore(disabledDate.startOf('d'))) {
            this.setState({
              selectedDate: timelogStore.timelog.id
                ? this.state.selectedDate
                : moment(),
            });
            showToast(
              'error',
              `You cannot selected beyond ${days} day/s prior to current day`
            );
          } else {
            this.setState({ selectedDate: date });
          }
        }
      } else {
        this.setState({
          selectedDate: timelogStore.timelog.id
            ? this.state.selectedDate
            : moment(),
        });
      }
    };
    const renderCalendar = (day, date) => {
      if (config && !masterAdmin) {
        const disabledDate = moment().subtract('day', days + 1);
        const currentDate = moment(date);
        if (currentDate.isBefore(disabledDate)) {
          const renderTest = (days) => {
            return (
              <p>
                You cannot add logs
                <span style={{ color: '#4A67DC' }}>
                  {` ${days} day/s `}
                </span>{' '}
                prior to current day.
              </p>
            );
          };
          return (
            <div class="dayContent holiday-nonWorkingDay">
              <span data-tooltip-id={`calendarDay_${day}`}>{day}</span>
              <Tooltip
                id={`calendarDay_${day}`}
                place="bottom"
                type="dark"
                multiline={true}
                effect="solid"
                clickable={true}
              >
                {renderTest(days)}
              </Tooltip>
            </div>
          );
        } else {
          return (
            <div class="dayContent">
              <span>{day}</span>
            </div>
          );
        }
      } else {
        return (
          <div class="dayContent">
            <span>{day}</span>
          </div>
        );
      }
    };
    const hasChanges = this.hasChanges();
    const isSaveEnabled = timelogStore.timelog.id
      ? hasChanges && timelogStore.timelog.id
      : true;

    const handleBlur = () => {
      const isVisible = $('#timelogDiscardChanges').is(':visible');
      if (!isVisible) {
        if (this.state.isModalReady) {
          this.handleDiscard();
        }
      }
      // this.setState({...this.state, show_timelog_modal: false});
    };

    return (
      <div>
        <div
          class={`modal fade common-add-modal ${task.Selected.id ? 'timeLogModalTaskPanel' : ''}`}
          data-backdrop="static"
          data-keyboard="false"
          id="logActivityTimeModal"
        >
          <ClickAwayListener onClickAway={handleBlur}>
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header bb">
                  <div class="row">
                    <div class="col-lg-10 col-md-10 col-sm-10">
                      <p class="modalTitle">{`${timelogStore.timelog.id ? 'Edit Time Log' : 'Log Time'}`}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2">
                      <a
                        class="text-right text-black"
                        aria-label="Close"
                        onClick={this.handleDiscard}
                      >
                        <i class="material-icons text-black text-size22">
                          close
                        </i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="form-group input-inline">
                    <label for="date" class="m0">
                      Date/ Time
                    </label>
                    <div class="inputContainer date-time-container">
                      <DatePicker
                        format="DD-MMM"
                        enableToday={true}
                        required={true}
                        selected={selectedDate}
                        minDate={
                          masterAdmin
                            ? null
                            : new Date(
                                moment()
                                  .subtract('day', days)
                                  .startOf('day')
                                  .format()
                              )
                        }
                        onChange={handleChangeDate}
                        popperClass="quickLinkDatePicker"
                        classes="form-control no-border"
                        renderDayContents={renderCalendar}
                      />
                      <Time
                        from={start}
                        to={end}
                        onChange={(e) => {
                          this.setState({ [e.name]: e.value });
                        }}
                        onBlur={this.handleOnBlurTime}
                      />
                    </div>
                  </div>

                  <div class="form-group input-inline">
                    <label for="account" class="m0">
                      Account
                    </label>
                    <div class="inputContainer">
                      <Account
                        onChange={this.handleChange}
                        timelog={timelog}
                        optClasses={`quickLinkModal`}
                        defaultValue={values.account}
                      />
                    </div>
                  </div>

                  <div class="form-group input-inline">
                    <label for="workstream" class="m0">
                      Workstream
                    </label>
                    <div class="inputContainer">
                      <Workstreams
                        onChange={this.handleChange}
                        timelog={timelog}
                        defaultSelected={selected.workstream}
                        optClasses={`quickLinkModal`}
                        defaultValue={values.workstream}
                      />
                    </div>
                  </div>

                  <div class="form-group input-inline">
                    <label for="task" class="m0">
                      Task
                    </label>
                    <div class="inputContainer">
                      <Tasks
                        onChange={this.handleChange}
                        restrictionDays={days}
                        masterAdmin={masterAdmin}
                        timelog={timelog}
                        optClasses={`quickLinkModal`}
                        defaultValue={values.task}
                      />
                    </div>
                  </div>

                  <div class="form-group descriptionContainer">
                    <label for="description" class="m0 mb10">
                      Description
                    </label>
                    <Description
                      description={description}
                      multiLine={true}
                      onChange={(e) => {
                        this.setState({ description: e.target.value });
                      }}
                    />
                  </div>
                </div>

                <div class="modal-footer">
                  <div class="btnContainer">
                    <button
                      type="button"
                      class="btn btnCancel"
                      onClick={this.handleDiscard}
                    >
                      Cancel
                    </button>
                    <a
                      class={`btn btnSave ${!isSaveEnabled ? 'disabled' : ''}`}
                      onClick={this.handleSave}
                    >
                      <span>{`${timelogStore.timelog.id ? 'Save' : 'Add'}`}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ClickAwayListener>
        </div>

        <Toast
          classes={{ options: `timelogToast` }}
          open={this.state.openToast}
          onClose={() => this.setState({ ...this.state, openToast: false })}
          timer={10000}
        >
          <span>
            Timelog Saved!{' '}
            <a href={`account#/my-timekeep`}>Click to view My Timekeep.</a>
          </span>
        </Toast>

        <DiscardChanges
          onCancel={this.onDiscardChanges}
          id={'timelogDiscardChanges'}
        />
        {/* <NavigationBLocker navigationBlocked={hasChanges}/> */}
      </div>
    );
  }
}

export default LogActivity;
